// removed by extract-text-webpack-plugin
module.exports = {"root":"DHghp","button":"_1dNpo","block":"xqfeL","input":"_3JEzA","fakeInput":"_2lrwV","checked":"_1aCP8","disabled":"_1x2JM"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Choice/styles.css
// module id = 1485
// module chunks = 6 8